/**
 * @desc 保存
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.LendMasterRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/lendMaster/save`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
